class StorefrontPlatformComparison extends HTMLElement {
  connectedCallback() {
    this.scrollArea = this.querySelector('[data-platform-scroll]');
    this.tabs = Array.from(this.querySelectorAll('[data-platform-tab]'));
    this.columns = Array.from(this.querySelectorAll('[data-platform-column]'));

    if (!this.scrollArea || this.tabs.length === 0 || this.columns.length === 0) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = Number(tab.dataset.platformTab || 0);
        this.scrollToColumn(index);
      });
    });

    this.scrollArea.addEventListener('scroll', () => this.syncActiveTab(), { passive: true });
    this.syncActiveTab();
  }

  scrollToColumn(index) {
    const column = this.columns[index];

    if (!column) return;

    this.scrollArea.scrollTo({
      left: column.offsetLeft,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });

    this.setActiveTab(index);
  }

  syncActiveTab() {
    const scrollLeft = this.scrollArea.scrollLeft;
    let activeIndex = 0;
    let activeDistance = Infinity;

    this.columns.forEach((column, index) => {
      const distance = Math.abs(column.offsetLeft - scrollLeft);

      if (distance < activeDistance) {
        activeDistance = distance;
        activeIndex = index;
      }
    });

    this.setActiveTab(activeIndex);
  }

  setActiveTab(activeIndex) {
    this.tabs.forEach((tab, index) => {
      tab.setAttribute('aria-pressed', index === activeIndex ? 'true' : 'false');
    });

    this.columns.forEach((column, index) => {
      column.toggleAttribute('data-platform-active', index === activeIndex);
    });
  }
}

if (!customElements.get('storefront-platform-comparison')) {
  customElements.define('storefront-platform-comparison', StorefrontPlatformComparison);
}
